import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const saveStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("authState", serializedState);
  } catch (error) {
    console.error("Error saving state to local storage:", error);
  }
};

export const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("authState");
    if (serializedState === null) {
      return {
        loading: false,
        isAuthenticated: false,
        user: null,
        error: null,
      };
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.error("Error loading state from local storage:", error);
    return undefined;
  }
};

const loginSuccess = createAsyncThunk(
  "auth/loginSuccess",
  async (user, { getState }) => {
    const state = {
      ...getState().auth,
      user: user,
    };

    saveStateToLocalStorage(state);

    return user;
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: loadStateFromLocalStorage() || {
    loading: false,
    isAuthenticated: false,
    user: null,
    error: null,
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
      localStorage.removeItem("authState");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginSuccess.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addDefaultCase((state) => {
        state.loading = false;
      });
  },
});

export const { loginStart, loginFailure, logout } = authSlice.actions;
export { loginSuccess };
export default authSlice.reducer;
